import {
  GET_LIGHT_STATE_SUCCESS,
  LISTEN_ZKTECO_FAIL,
  LISTEN_ZKTECO_REQUEST,
  LISTEN_ZKTECO_SUCCESS,
  OPEN_TRB_FAIL,
  OPEN_TRB_REQUEST,
  OPEN_TRB_SUCCESS,
  OPEN_ZKTECO_FAIL,
  OPEN_ZKTECO_REQUEST,
  OPEN_ZKTECO_SUCCESS,
  SUBMIT_AUTO_SCALE_FAIL,
  SUBMIT_AUTO_SCALE_REQUEST,
  SUBMIT_AUTO_SCALE_SUCCESS,
  UPDATE_AUTO_SCALE_FAIL,
  UPDATE_AUTO_SCALE_REQUEST,
  UPDATE_AUTO_SCALE_SUCCESS,
} from "src/constants/types";

export const autoScaleReducers = (state = {}, actions) => {
  switch (actions.type) {
    case SUBMIT_AUTO_SCALE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case SUBMIT_AUTO_SCALE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case SUBMIT_AUTO_SCALE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };
    case UPDATE_AUTO_SCALE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_AUTO_SCALE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case UPDATE_AUTO_SCALE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };
    case OPEN_TRB_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case OPEN_TRB_SUCCESS:
      return {
        ...state,
        loading: false,
        opened: actions.payload,
      };
    case GET_LIGHT_STATE_SUCCESS:
      return {
        ...state,
        loading: false,
        lightState: actions.payload,
      };
    case OPEN_TRB_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };
    case OPEN_ZKTECO_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case OPEN_ZKTECO_SUCCESS:
      return {
        ...state,
        loading: false,
        opened: actions.payload,
      };
    case OPEN_ZKTECO_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };
    case LISTEN_ZKTECO_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case LISTEN_ZKTECO_SUCCESS:
      return {
        ...state,
        loading: false,
        read: actions.payload,
      };
    case LISTEN_ZKTECO_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };
    default:
      return state;
  }
};
